// extracted by mini-css-extract-plugin
module.exports = {"VpcListOptions":"VpcListOptions_RamNV","VpcDropdownMenu":"VpcDropdownMenu_--sCl"};